export default __webpack_public_path__ + "static/media/iconButtonRestaurar.f8984ba4.svg";